import { render } from "./Article.vue?vue&type=template&id=cba83302&scoped=true&ts=true"
import script from "./Article.vue?vue&type=script&lang=ts"
export * from "./Article.vue?vue&type=script&lang=ts"

import "./Article.vue?vue&type=style&index=0&id=cba83302&scoped=true&lang=css"

import exportComponent from "G:\\Storage\\VSCodeProjects\\MineMCPay\\minemcpay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cba83302"]])

export default __exports__